import React from 'react'
import { Mail, MessageCircle, Github, Linkedin, Twitter, MapPin, Users, ShoppingCart } from 'lucide-react'

const Contact = () => {
  const contactMethods = [
    {
      title: "项目合作",
      description: "AI技术咨询、产品开发、技术分享",
      icon: MessageCircle,
      color: "from-blue-500 to-cyan-600",
      action: "联系洽谈"
    },
    {
      title: "技术交流",
      description: "算法讨论、架构设计、经验分享",
      icon: Github,
      color: "from-purple-500 to-pink-600",
      action: "技术探讨"
    },
    {
      title: "学习分享",
      description: "AI学习心得、旅行见闻、人生感悟",
      icon: Mail,
      color: "from-green-500 to-teal-600",
      action: "交流学习"
    }
  ]

  const socialLinks = [
    {
      name: "GitHub",
      icon: Github,
      url: "https://github.com/PolarTechJordan",
      color: "hover:text-gray-900"
    },
    {
      name: "LinkedIn",
      icon: Linkedin,
      url: "#",
      color: "hover:text-blue-600"
    },
    {
      name: "Twitter",
      icon: Twitter,
      url: "#",
      color: "hover:text-blue-400"
    }
  ]

  return (
    <section id="contact" className="section-padding bg-white">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="gradient-text mb-4">联系我</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            期待与您的交流，无论是技术探讨、项目合作，还是人生感悟的分享
          </p>
        </div>

        {/* 联系方式 */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {contactMethods.map((method, index) => (
            <div key={index} className="card text-center hover:scale-105 transform transition-all duration-300 group">
              <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${method.color} flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <method.icon size={32} className="text-white" />
              </div>
              
              <h3 className="text-xl font-bold text-gray-800 mb-3">{method.title}</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">{method.description}</p>
              
              <button className="btn-primary hover:scale-105 transform transition-all duration-300">
                {method.action}
              </button>
            </div>
          ))}
        </div>

        {/* 联系信息 */}
        <div className="max-w-4xl mx-auto">
          <div className="card bg-gradient-to-r from-primary-50 to-accent-50 border-2 border-primary-100">
            <div className="grid md:grid-cols-2 gap-8">
              {/* 基本信息 */}
              <div>
                <h3 className="text-xl font-bold text-gray-800 mb-6">基本信息</h3>
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <MapPin size={20} className="text-primary-600" />
                    <span className="text-gray-700">全球数字游民</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <Mail size={20} className="text-primary-600" />
                    <span className="text-gray-700">polartech_jordan@163.com</span>
                  </div>
                </div>
              </div>

              {/* 社交媒体 */}
              <div>
                <h3 className="text-xl font-bold text-gray-800 mb-6">社交媒体</h3>
                <div className="flex gap-4">
                  {socialLinks.map((social, index) => (
                    <a
                      key={index}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`w-12 h-12 rounded-full bg-white shadow-md flex items-center justify-center text-gray-600 ${social.color} hover:scale-110 transform transition-all duration-300`}
                    >
                      <social.icon size={20} />
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 项目链接 */}
        <div className="mt-16">
          <h3 className="text-2xl font-bold text-center text-gray-800 mb-8">我的项目</h3>
          <div className="grid md:grid-cols-3 gap-6">
            <a
              href="https://sxyz.space/"
              target="_blank"
              rel="noopener noreferrer"
              className="card text-center hover:scale-105 transform transition-all duration-300 group"
            >
              <div className="w-12 h-12 bg-gradient-to-br from-pink-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                <MessageCircle size={24} className="text-white" />
              </div>
              <h4 className="font-semibold text-gray-800 mb-2">冥想社区工具</h4>
              <p className="text-gray-600 text-sm">心理健康 · 正念练习</p>
            </a>

            <a
              href="https://temple.polarjordan.xyz/"
              target="_blank"
              rel="noopener noreferrer"
              className="card text-center hover:scale-105 transform transition-all duration-300 group"
            >
              <div className="w-12 h-12 bg-gradient-to-br from-yellow-500 to-orange-600 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                <MapPin size={24} className="text-white" />
              </div>
              <h4 className="font-semibold text-gray-800 mb-2">东玄上香祈福</h4>
              <p className="text-gray-600 text-sm">传统文化 · 数字化体验</p>
            </a>

            <a
              href="https://tarot.polarjordan.xyz/"
              target="_blank"
              rel="noopener noreferrer"
              className="card text-center hover:scale-105 transform transition-all duration-300 group"
            >
              <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                <Twitter size={24} className="text-white" />
              </div>
              <h4 className="font-semibold text-gray-800 mb-2">西玄塔罗占卜</h4>
              <p className="text-gray-600 text-sm">AI占卜 · 玄学科技</p>
            </a>

            <a
              href="https://campus.polarjordan.xyz/"
              target="_blank"
              rel="noopener noreferrer"
              className="card text-center hover:scale-105 transform transition-all duration-300 group"
            >
              <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                <Users size={24} className="text-white" />
              </div>
              <h4 className="font-semibold text-gray-800 mb-2">校园模拟游戏</h4>
              <p className="text-gray-600 text-sm">AI游戏 · 校园RPG</p>
            </a>

            <a
              href="https://polarjordan.online/"
              target="_blank"
              rel="noopener noreferrer"
              className="card text-center hover:scale-105 transform transition-all duration-300 group"
            >
              <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                <ShoppingCart size={24} className="text-white" />
              </div>
              <h4 className="font-semibold text-gray-800 mb-2">电商交易平台</h4>
              <p className="text-gray-600 text-sm">AI Agent · 自动化交易</p>
            </a>
          </div>
        </div>

        {/* 结语 */}
        <div className="mt-16 text-center">
          <blockquote className="text-lg italic text-gray-700 max-w-3xl mx-auto">
            "在这个快速变化的AI时代，让我们一起探索技术的边界，<br/>
            分享成长的喜悦，用代码连接世界，用心灵温暖彼此。"
          </blockquote>
          <div className="mt-4 text-gray-500">— 期待与您的相遇</div>
        </div>
      </div>
    </section>
  )
}

export default Contact 